import { render } from "./gcp.vue?vue&type=template&id=7c13b6bc"
import script from "./gcp.vue?vue&type=script&lang=js"
export * from "./gcp.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__